/**
 * Sincronização entre os valores vindos do servidor e o estado local do editor de campos
 * personalizados.
 *
 * O editor é re-renderizado com frequência (as telas de detalhe têm um contador de SLA que
 * dispara a cada segundo), então o efeito de sincronização roda muitas vezes enquanto o
 * usuário digita. Comparar o valor local com o do banco não serve para decidir: qualquer
 * edição ainda não salva aparece como divergência e seria descartada.
 *
 * A decisão correta é olhar apenas para o servidor: só adotamos o valor remoto quando ele
 * mudou desde a última sincronização (carga inicial, gravação, alteração de outra pessoa).
 */

/** Marca um campo que ainda não possui registro de valor no servidor. */
export const NO_SERVER_VALUE = '\u0000sem-valor';

/** Assinatura estável do valor remoto, usada para detectar mudanças reais do servidor. */
export function serverValueSignature(
  existingValue: { text_value?: string | null } | undefined | null
): string {
  if (!existingValue) return NO_SERVER_VALUE;
  return existingValue.text_value ?? '';
}

export function shouldAdoptServerFieldValue(params: {
  currentValue: unknown;
  serverSignature: string;
  lastSyncedSignature: string | undefined;
}): boolean {
  const { currentValue, serverSignature, lastSyncedSignature } = params;
  if (currentValue === undefined) return true;
  return lastSyncedSignature !== serverSignature;
}
